/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import {
    FETCH_COLLECTION_PDFS_FAILURE,
    FETCH_COLLECTION_PDFS_REQUEST,
    FETCH_COLLECTION_PDFS_SUCCESS
} from '../_actions/pdf.links.actions';
import { CLEAR_COLLECTION } from '../_actions/collection.actions';

export const INITIAL_STATE = {isFetching: false, printContents: []};

export function pdfLinksReducer (state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_COLLECTION_PDFS_REQUEST: {
            return {...state, isFetching: true};
        }
        case FETCH_COLLECTION_PDFS_SUCCESS: {
            return { printContents: action.payload, isFetching: false };
        }
        case FETCH_COLLECTION_PDFS_FAILURE: {
            return {...state, isFetching: false};
        }
        case CLEAR_COLLECTION: {
            return INITIAL_STATE;
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/pdf.links.reducer.js